import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useAttachments = (model, id, page = 1) => useQuery({ queryKey: [`${id}-attachments`, page], queryFn: async () => {
    const callback = await API.get(`/${model}/${id}/attachments?page=${page}`)
    return callback?.data
}})

export default useAttachments